"use client";
import "./ExpertListCard.scss";
import Image from "next/image";
import Link from "next/link";
import ForRating from "@/components/Rating/ForRating";

export default function ExpertListCard({ listitem, type }) {
  return (
    <div className="expertsDetail w-full max-w-[330px]">
      <div
        style={{
          position: "relative",
          width: "120px",
          height: "120px",
        }}
      >
        <Image
          loading="lazy"
          src={listitem?.img?.url}
          alt={listitem?.name || "\u00A0"}
          fill
          style={{ objectFit: "cover" }}
          className="rounded-full"
        />
      </div>

      <div className="expertInfo">
        <div>
          <ForRating
            initialValue={listitem?.rating || 4}
            allowFraction={true}
            size={20}
            readonly
          />
        </div>
        <p className="name">{listitem?.name || "\u00A0"}</p>
        <p className="level">{listitem?.level || "\u00A0"}</p>
        <p className="designation">{listitem?.designation || "\u00A0"}</p>
        <p className="value">
          <span className="highlight">Experience:</span>{" "}
          {listitem?.experience || "\u00A0"}
        </p>
        <p className="value">
          <span className="highlight">Classes:</span>{" "}
          {listitem?.classes || "\u00A0"}
        </p>
        <p className="value">
          <span className="highlight">Location:</span>{" "}
          {listitem?.location || "\u00A0"}
        </p>
      </div>

      {listitem?.slug && (
        <Link
          className="viewDetailContainer"
          href={`/${type}-experts/${listitem?.slug}`}
        >
          <button className="viewDetailBtn">View Detail</button>
        </Link>
      )}
    </div>
  );
}
